import { Modal } from 'antd-mobile'
const alertModal = Modal.alert

export const clone = (object) => {
  return JSON.parse(JSON.stringify(object))
}

export const sendToLog = (name, object) => {
  if (process.env.REACT_APP_ENV !== 'PRO') {
  }
}

export const getDataUser = (token) => {
  if (token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(jsonPayload)
  }
}

export const openAlert = (title, message, buttons) => {
  const alertInstance = alertModal(title, message, buttons)
  setTimeout(() => {
    alertInstance.close()
  }, 500000)
}

export const getTypeServiceDescription = (typeServiceId) => {
  switch (typeServiceId) {
    case 0:
      return 'Management'
    case 1:
      return 'Purchase'
    case 2:
      return 'Mantenimiento'
    case 3:
      return 'Indirecto'
    case 4:
      return 'SLB'
    case 5:
      return 'Truck'
    default:
      return ''
  }
}

export const textToolsGetWrappedText500 = (text) => {
  if (!text) {
    return ''
  }
  if (text.length > 500) {
    return `${text.substring(0, 500)} ...`
  } else {
    return text
  }
}

export const getIcon = (typeServiceId, status) => {
  switch (typeServiceId.toString() + '_' + status) {
    case '0_ProcessInTime':
      return 'file'
    case '0_ProcessOutOfTime':
      return 'clock-circle'
    case '0_Reception':
      return 'download'
    case '0_Check':
      return 'file-done'
    case '0_OutstandingPayment':
      return 'dollar'
    case '0_Paid':
      return 'check'
    case '0_MyTasks':
      return 'star'
    default:
      return ''
  }
}

export const getPurchaseDashboardIcon = (status) => {
  switch (status) {
    case 0:
      return 'file-text'
    case 25:
      return 'file-unknown'
    case 17:
      return 'check'
    case 27:
      return 'clock-circle'
    case 28:
      return 'file-done'
    case -1:
      return 'close-square'
    default:
      return 'file'
  }
}
export const getMaintenanceDashboardIcon = (status) => {
  switch (status) {
    case 0:
      return 'file'
    case 3:
      return 'exclamation-circle'
    case 6:
      return 'file-search'
    case 9:
      return 'close-square'
    case 12:
      return 'clock-circle'
    case 15:
      return 'file-done'
    default:
      return 'file'
  }
}
export const getCollateralDashboardIcon = (stage) => {
  switch (stage) {
    case 'ProcesoDentroDeTiempo':
      return 'file'
    case 'ProcesoFueraDeTiempo':
      return 'exclamation-circle'
    case 'Tramite':
      return 'clock-circle'
    case 'Comprobacion':
      return 'check-square'
    case 'PagoPendiente':
      return 'file-search'
    case 'Finalizado':
      return 'file-done'
    default:
      return 'file'
  }
}

export const getTelematicsDashboardIcon = (stage) => {
  switch (stage) {
    case 'ConProveedor'  :
      return 'file' 
    case 'EnProceso':
      return 'check-circle' 
    case 'EnFacturacion':
      return 'dollar'
    case 'Finalizada': 
      return 'file-done' 
  
    default:
      return ''
  }
}

export const getIndirectDashboardIcon = (status) => {
  switch (status) {
    case 2:
      return 'file-unknown' //sin factura
    case 27:
      return 'file' // con factura recibida
    case 5:
      return 'close-square'//Rechazada
    case 11:
      return 'exclamation-circle' //no pagada
    case 14: 
      return 'file-done' // pagadas
   
    default:
      return ''
  }
}
export const TypeService = {
  Management: 0,
  VehiclesAcquisition: 1
}

export const formatDate = (date) => {
  if (!date) { return '' }
  return date.substring(8, 10) + '/' + date.substring(5, 7) + '/' + date.substring(0, 4) + ' ' +
    date.substring(11, 13) + ':' + date.substring(14, 16)
}

export const DashboardDescription = {
  ProcessInTime: 'ProcessInTime',
  ProcessOutOfTime: 'ProcessOutOfTime',
  Reception: 'Reception',
  Check: 'Check',
  OutstandingPayment: 'OutstandingPayment',
  Paid: 'Paid',
  MyTasks: 'MyTasks'
}

export const StatusGroup = {
  ProcessInTime: 0,
  ProcessOutOfTime: 1,
  Reception: 2,
  Check: 3,
  OutstandingPayment: 4,
  Paid: 5,
  MyTasks: 6
}

export const SubStatus = {
  Cancelled: -1,
  ProcessInTime: 0,
  ProcessAboutToExpire: 1,
  ProcessOutOfTimeLessThan15Days: 2,
  ProcessOutOfTimeGreaterThan15Days: 3,
  Reception: 4,
  CheckPending: 5,
  CheckInReview: 6,
  CheckRejected: 7,
  OutstandingPayment: 8,
  Paid: 9
}

export const getStatusGroupValue = (statusGroupDescription) => {
  switch (statusGroupDescription) {
    case 'ProcessInTime':
      return 0
    case 'ProcessOutOfTime':
      return 1
    case 'Reception':
      return 2
    case 'Check':
      return 3
    case 'OutstandingPayment':
      return 4
    case 'Paid':
      return 5
    default:
      return
  }
}
